import React, { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";



const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 10px;

  border-radius: 5px;

  h2 {
    color: #575757;
  }

`;



const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  width: 98%;   
  margin: auto;   
  padding: 12px;
`;


export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;





const Tr = styled.tr`
  text-align: center;
  gap: 5px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;

const Td = styled.td`
  
  font-size: 14px;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align:start;
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 10px 0px;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 345px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Grid = ({ logsAlteracao }) => {


  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(logsAlteracao);
  const [isLoading, setIsLoading] = useState(true);

  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = logsAlteracao.filter((user) => {
        const cracha = (user.COD_FUNCIONARIO || '').toString().toLowerCase();
        const login = (user.LOGON || '').toLowerCase();
        const nome = (user.NOME || '').toLowerCase();


        return (
          cracha.includes(term.toLowerCase()) ||
          login.includes(term.toLowerCase()) ||
          nome.includes(term.toLowerCase())

        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, logsAlteracao]);


  //---------------------------------------FUNÇÂO DE ORDENAÇÂO---------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);


  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };


  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };


  //--------------------------------------------------------------------------------------------------------------//

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };


  //------------------------------------------------------------------------------------------//

  return (



    <Container>
      <h2>Logs de alteração dos usuários:</h2>
      <Td3 colSpan="7">
        <Input
          type="text"
          placeholder="Pesquisar... Ex: login, nome ou crachá"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Div>
          <Button onClick={handlePrevPage} disabled={currentPage === 1}>
            <ImArrowLeft size={20} />
          </Button>
          <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ImArrowRight size={20} />
          </Button>
        </Div>


      </Td3>
      {currentItems.length === 0 ? (
        <Tr>
          <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
            Nenhum log encontrado.
          </Td>
        </Tr>
      ) : (
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th onClick={() => onColumnClick("COD_FUNCIONARIO")} className={getSortClass("COD_FUNCIONARIO")}>
                  Crachá {getSortIcon("COD_FUNCIONARIO")}
                </th>

                <th onClick={() => onColumnClick("LOGON")} className={getSortClass("LOGON")}>
                  Login {getSortIcon("LOGON")}
                </th>

                <th onClick={() => onColumnClick("DESC_LOG")} className={getSortClass("DESC_LOG")}>
                  Descrição {getSortIcon("DESC_LOG")}
                </th>

                <th onClick={() => onColumnClick("DATA_LOG")} className={getSortClass("DATA_LOG")}>
                  Data {getSortIcon("DATA_LOG")}
                </th>



              </tr>
            </thead>

            <tbody>
              {currentItems.map((item, i) => (
                <tr key={i}>
                  <td >{item.COD_FUNCIONARIO}</td>
                  <td >{item.LOGON}</td>
                  <td >{item.DESC_LOG}</td>
                  <td >{item.DATA_LOG
                    ? new Date(item.DATA_LOG).toLocaleString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: false,
                    })
                    : ""}</td>


                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      )}
    </Container>
  );
};


export default Grid;
